import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationPayloadType {
  dismissed?: boolean;
  options?: {
    key?: number;
    variant?: 'error' | 'default' | 'success' | 'warning' | 'info';
  };
  message: string;
}
interface NotificationType extends NotificationPayloadType {
  key: string | number;
}

type InitialStateType = {
  notifications: NotificationType[];
};

const initialState: InitialStateType = {
  notifications: [],
};
const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addSnackbar: (state, action: PayloadAction<NotificationPayloadType>) => {
      const notification = action.payload;
      state.notifications.push({ ...notification, message: notification.message || 'Server Error', key: `${new Date().getTime() + Math.random()}` });
    },
    closeSnackbar: (state, action: PayloadAction<string | number>) => {
      const key = action.payload;
      state.notifications = state.notifications.map((notification) => {
        const shouldDismiss = !key || notification.key === key;
        return shouldDismiss ? { ...notification, dismissed: true } : { ...notification };
      });
    },
    removeSnackbar: (state, { payload }) => {
      state.notifications = state.notifications.filter((notification) => notification.key !== payload);
    },
  },
});

export default snackbarSlice.reducer;
export const { addSnackbar, closeSnackbar, removeSnackbar } = snackbarSlice.actions;
